export var addScrollHandler = function addScrollHandler(onScrollFunction) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  element.addEventListener("touchmove", onScrollFunction, element);
  element.addEventListener("scroll", onScrollFunction, element);
};
export var removeScrollHandler = function removeScrollHandler(onScrollFunction) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  element.removeEventListener("touchmove", onScrollFunction);
  element.removeEventListener("scroll", onScrollFunction);
};
export var getScrollingElement = function getScrollingElement() {
  return window.document.scrollingElement || window.document.documentElement;
};